import { API_URL } from "./apiRoutes";

/**
 * Lista endpointów, które nie powinny mieć automatycznie dodawanego parametru userLanguage.
 * 
 * Powody wykluczenia mogą obejmować:
 * - Endpointy zwracające dane strukturalne (np. dostępność w kalendarzu)
 * - Endpointy, które nie obsługują wielojęzyczności po stronie backendu
 * - Endpointy, gdzie język jest określany w inny sposób
 * 
 * Format: Podaj fragment ścieżki URL, który jednoznacznie identyfikuje endpoint.
 */
const URL_LANGUAGE_PARAM_EXCLUSIONS: string[] = [
  // "/EAktywni/attractions/calendar",
  // "/EAktywni/exercises/datesAndFacility"
  // Dodaj kolejne endpointy tutaj w miarę potrzeb
];

const isUrlExcludedFromLanguageParam = (url: string): boolean => {
  return URL_LANGUAGE_PARAM_EXCLUSIONS.some((exclusion) => url.includes(exclusion));
};

const addLanguageParamToUrl = (url: string) => {
  // Sprawdź, czy URL jest na liście wykluczeń
  if (isUrlExcludedFromLanguageParam(url)) {
    return "";
  }

  const localStorageLng = localStorage.getItem("i18nextLng");
  if (localStorageLng && localStorageLng !== "PL") {
    const separator = url.includes("?") ? "&" : "?";
    return `${separator}userLanguage=${localStorageLng}`;
  } else {
    return "";
  }
};

export const post = async (url: string, data = {}, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    signal,
    body: JSON.stringify(data),
  });
  return await response.json();
};

export const postMultipart = async (url: string, data: FormData, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "POST",
    signal,
    body: data,
  });
  return await response.json();
};

export const get = async (url: string, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "GET",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    signal,
  });
  return await response.json();
};

export const del = async (url: string, data = {}, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "DELETE",
    mode: "cors",
    signal,
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    body: JSON.stringify(data),
  });
  return await response.json();
};

export const put = async (url: string, data = {}, signal?: AbortSignal) => {
  const response = await fetch(getFullURL(url), {
    method: "PUT",
    mode: "cors",
    signal,
    headers: {
      "Content-Type": "application/json",
    },
    redirect: "follow",
    body: JSON.stringify(data),
  });
  return await response.json();
};

const getFullURL = (url: string) => `${API_URL}${url}${addLanguageParamToUrl(url)}`;
